import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FormStateModel } from '@libs/form/models';

export function createInitialState(): FormStateModel {
  return {
    currentStep: 0,
    value: {},
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'form' })
export class FormStateStore extends Store<FormStateModel> {
  public constructor() {
    super(createInitialState());
  }
}
